import { API } from "../api";

const BASE_URL = "/members/settings/support";

export const memberSupportApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getMemberSupportInfo: builder.query({
      query: () => `${BASE_URL}?guard=member`,
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "MemberSupportInfo", id: "CURRENT" }],
    }),
  }),
});

export const { useGetMemberSupportInfoQuery } = memberSupportApi;
